var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSellYourCar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10984",
    "data-name": "Group 10984",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400.522,
    height: 170.73,
    viewBox: "0 0 400.522 170.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3259",
    "data-name": "Rectangle 3259",
    width: 400.522,
    height: 170.731,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3258",
    "data-name": "Rectangle 3258",
    width: 400.523,
    height: 170.731,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3245",
    "data-name": "Rectangle 3245",
    width: 53.673,
    height: 53.673,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3247",
    "data-name": "Rectangle 3247",
    width: 174.971,
    height: 45.458,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3248",
    "data-name": "Rectangle 3248",
    width: 56.813,
    height: 32.364,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3249",
    "data-name": "Rectangle 3249",
    width: 32.191,
    height: 26.562,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3250",
    "data-name": "Rectangle 3250",
    width: 49.453,
    height: 36.713,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3251",
    "data-name": "Rectangle 3251",
    width: 73.311,
    height: 45.45,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3252",
    "data-name": "Rectangle 3252",
    width: 64.453,
    height: 44.17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3253",
    "data-name": "Rectangle 3253",
    width: 42.966,
    height: 33.159,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3254",
    "data-name": "Rectangle 3254",
    width: 173.113,
    height: 43.49,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3255",
    "data-name": "Rectangle 3255",
    width: 50.875,
    height: 27.336,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10983",
    "data-name": "Group 10983",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10982",
    "data-name": "Group 10982"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10981",
    "data-name": "Group 10981",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29537",
    "data-name": "Path 29537",
    d: "M1505.537,470.029H1420.8v-4.747a36.4,36.4,0,0,1,36.395-36.395h11.949a36.4,36.4,0,0,1,36.395,36.395Z",
    transform: "translate(-1127.121 -340.237)",
    fill: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29538",
    "data-name": "Path 29538",
    d: "M1471.495,511.589h.019c0-.106,0-.211,0-.317s0-.212,0-.318h-.019a.179.179,0,0,1-.174-.184l.025-.883a.179.179,0,0,1,.184-.174h.018c.01-.212.023-.423.037-.634l-.018,0a.179.179,0,0,1-.163-.194l.076-.88a.179.179,0,0,1,.194-.163h.015q.033-.317.072-.631l-.015,0a.179.179,0,0,1-.152-.2l.125-.874a.179.179,0,0,1,.2-.152l.014,0c.034-.209.069-.418.106-.626l-.012,0a.179.179,0,0,1-.14-.211l.175-.865a.179.179,0,0,1,.211-.14l.012,0q.068-.311.143-.619l-.011,0a.179.179,0,0,1-.128-.219l.224-.854a.179.179,0,0,1,.219-.128l.009,0c.057-.2.119-.407.18-.609l-.01,0a.179.179,0,0,1-.115-.226l.273-.84a.179.179,0,0,1,.225-.115l.01,0c.069-.2.139-.4.212-.6l-.008,0a.179.179,0,0,1-.1-.232l.32-.823a.179.179,0,0,1,.232-.1l.01,0q.121-.294.248-.585l-.01,0a.179.179,0,0,1-.088-.237l.366-.8a.179.179,0,0,1,.238-.089l.009,0c.092-.191.187-.38.282-.569l-.01-.005a.179.179,0,0,1-.075-.242l.412-.781a.179.179,0,0,1,.242-.075l.011.006c.1-.185.206-.37.312-.553l-.01-.006a.179.179,0,0,1-.061-.246l.456-.756a.179.179,0,0,1,.246-.061l.013.008q.169-.269.344-.534l-.013-.009a.179.179,0,0,1-.047-.249l.5-.729a.179.179,0,0,1,.249-.047l.012.008q.184-.259.374-.513l-.013-.01a.18.18,0,0,1-.033-.251l.539-.7a.179.179,0,0,1,.251-.032l.015.011q.2-.247.4-.492l-.014-.012a.18.18,0,0,1-.018-.253l.578-.667a.179.179,0,0,1,.253-.018l.014.012c.142-.157.285-.313.43-.467l-.013-.013a.179.179,0,0,1,0-.253l.615-.633a.179.179,0,0,1,.253,0l.013.013c.15-.149.3-.3.454-.443l-.011-.013a.179.179,0,0,1,.011-.253l.651-.6a.179.179,0,0,1,.253.011l.013.014q.238-.21.479-.416l-.012-.014a.179.179,0,0,1,.025-.252l.684-.559a.179.179,0,0,1,.252.025l.01.012q.25-.2.5-.387l-.01-.014a.179.179,0,0,1,.04-.25l.715-.519a.179.179,0,0,1,.25.04l.01.013c.173-.121.347-.242.523-.36l-.008-.012a.179.179,0,0,1,.054-.248l.743-.477a.179.179,0,0,1,.248.054l.008.012q.27-.167.544-.328l-.007-.012a.179.179,0,0,1,.068-.244l.769-.434a.18.18,0,0,1,.244.068l.006.01q.279-.151.562-.3l0-.01a.179.179,0,0,1,.082-.24l.792-.39a.179.179,0,0,1,.24.082l.005.01q.288-.135.577-.265l0-.009a.18.18,0,0,1,.1-.235l.813-.344a.179.179,0,0,1,.234.1l0,.009q.294-.118.592-.23l0-.01a.179.179,0,0,1,.108-.229l.832-.3a.179.179,0,0,1,.229.109l0,.008q.3-.1.6-.2l0-.009a.179.179,0,0,1,.122-.222l.847-.249a.179.179,0,0,1,.222.121l0,.011c.2-.056.409-.11.615-.162l0-.011a.179.179,0,0,1,.134-.215l.86-.2a.179.179,0,0,1,.215.134l0,.012c.207-.044.414-.085.623-.125l0-.013a.179.179,0,0,1,.146-.207l.87-.151a.179.179,0,0,1,.207.146l0,.012c.209-.032.419-.06.629-.088l0-.015a.179.179,0,0,1,.157-.2l.877-.1a.179.179,0,0,1,.2.157l0,.017c.211-.02.421-.04.633-.055V478.5a.179.179,0,0,1,.169-.189l.881-.05a.179.179,0,0,1,.189.168s.5,0,.5,0l.039-.019c0-.1-.015-.166.084-.166h1.037c.1,0,.03.067.03.166l.016.019c.509,0,.8,0,.8,0,.006-.1,0-.174.1-.168l1.048.05c.1.006.05.09.05.189v.016c0,.016.555.035.766.055l-.041-.017a.161.161,0,0,1,.177-.157l.866.1a.175.175,0,0,1,.152.2l0,.015c.21.028.419.056.627.088v-.013a.179.179,0,0,1,.207-.146l.87.151a.179.179,0,0,1,.146.207l0,.013c.208.04.416.081.623.125l0-.012a.179.179,0,0,1,.215-.134l.86.2a.179.179,0,0,1,.134.215l0,.011c.206.052.41.106.614.162l0-.011a.179.179,0,0,1,.222-.121l.847.249a.179.179,0,0,1,.121.222l0,.009q.3.1.6.2l0-.008a.18.18,0,0,1,.229-.109l.832.3a.179.179,0,0,1,.109.229l0,.01c.2.075.4.151.592.23l0-.009a.179.179,0,0,1,.235-.1l.813.344a.179.179,0,0,1,.1.235l0,.009q.29.13.577.265l.005-.01a.179.179,0,0,1,.24-.082l.792.39a.179.179,0,0,1,.082.24l-.005.01q.283.146.562.3l.006-.01a.179.179,0,0,1,.244-.068l.769.434a.179.179,0,0,1,.068.244l-.007.012q.274.162.544.328l.008-.012a.179.179,0,0,1,.248-.054l.743.477a.179.179,0,0,1,.054.248l-.008.012c.176.118.35.239.523.36l.01-.013a.179.179,0,0,1,.25-.04l.715.519a.179.179,0,0,1,.04.25l-.01.014c.169.128.337.256.5.387l.01-.012a.179.179,0,0,1,.252-.025l.683.559a.179.179,0,0,1,.025.252l-.012.015q.242.206.479.416l.013-.014a.179.179,0,0,1,.253-.011l.651.6a.179.179,0,0,1,.011.253l-.011.013c.153.146.3.295.454.443l.013-.013a.179.179,0,0,1,.253,0l.615.633a.179.179,0,0,1,0,.253l-.014.013q.217.232.43.467l.014-.012a.179.179,0,0,1,.253.018l.578.667a.179.179,0,0,1-.018.253l-.013.012c.136.162.269.327.4.492l.015-.011a.179.179,0,0,1,.251.032l.539.7a.179.179,0,0,1-.032.251l-.013.01q.19.255.374.513l.013-.008a.179.179,0,0,1,.249.047l.5.729a.179.179,0,0,1-.047.249l-.013.009q.174.265.344.534l.013-.008a.179.179,0,0,1,.246.061l.456.756a.179.179,0,0,1-.061.246l-.011.006c.106.183.209.368.312.553l.011-.006a.179.179,0,0,1,.242.075l.412.781a.179.179,0,0,1-.075.242l-.01.005c.1.189.19.378.282.569l.009,0a.179.179,0,0,1,.237.089l.367.8a.179.179,0,0,1-.088.237l-.01,0q.126.291.247.585l.01,0a.179.179,0,0,1,.232.1l.32.823a.179.179,0,0,1-.1.232l-.008,0c.073.2.143.4.212.6l.009,0a.179.179,0,0,1,.226.115l.273.84a.179.179,0,0,1-.115.226l-.01,0c.062.2.123.405.18.609l.009,0a.179.179,0,0,1,.219.128l.224.854a.18.18,0,0,1-.128.219l-.012,0q.075.308.144.619l.012,0a.179.179,0,0,1,.211.14l.175.865a.179.179,0,0,1-.14.211l-.012,0c.038.208.073.417.106.626l.014,0a.179.179,0,0,1,.2.152l.125.874a.179.179,0,0,1-.152.2l-.015,0q.039.315.072.631h.015a.179.179,0,0,1,.194.163l.076.88a.179.179,0,0,1-.163.194l-.018,0c.014.211.027.422.036.634h.018a.179.179,0,0,1,.184.174l.025.883a.179.179,0,0,1-.174.184h-.02c0,.106,0,.211,0,.317s0,.211,0,.317h.02a.179.179,0,0,1,.174.184l-.025.882a.179.179,0,0,1-.184.174h-.018c-.01.212-.023.423-.036.634l.018,0a.179.179,0,0,1,.163.194l-.076.88a.179.179,0,0,1-.194.163h-.015q-.033.316-.072.631l.015,0a.179.179,0,0,1,.152.2l-.125.874a.179.179,0,0,1-.2.152l-.014,0c-.034.209-.068.418-.106.626l.012,0a.179.179,0,0,1,.14.211l-.175.865a.179.179,0,0,1-.211.14l-.012,0q-.069.311-.144.619l.012,0a.179.179,0,0,1,.128.219l-.224.854a.179.179,0,0,1-.219.128l-.009,0c-.058.2-.119.407-.18.609l.01,0a.179.179,0,0,1,.115.226l-.273.84a.179.179,0,0,1-.226.115l-.009,0c-.069.2-.139.4-.212.6l.008,0a.179.179,0,0,1,.1.232l-.32.823a.179.179,0,0,1-.232.1l-.01,0q-.121.294-.247.585l.01,0a.179.179,0,0,1,.089.237l-.367.8a.179.179,0,0,1-.238.089l-.009,0c-.092.191-.187.38-.282.569l.01.006a.179.179,0,0,1,.075.242l-.412.781a.179.179,0,0,1-.242.075l-.011-.006c-.1.185-.206.37-.312.553l.011.006a.179.179,0,0,1,.061.246l-.456.756a.179.179,0,0,1-.246.061l-.013-.007q-.169.268-.344.534l.013.009a.179.179,0,0,1,.047.249l-.5.729a.179.179,0,0,1-.249.047l-.013-.008q-.184.259-.374.513l.013.01a.18.18,0,0,1,.032.251l-.539.7a.179.179,0,0,1-.251.033l-.014-.011c-.132.165-.266.329-.4.492l.013.012a.179.179,0,0,1,.018.253l-.578.667a.18.18,0,0,1-.253.018l-.014-.012c-.142.157-.285.313-.43.467l.014.013a.179.179,0,0,1,0,.253l-.615.633a.179.179,0,0,1-.253,0l-.013-.013c-.15.149-.3.3-.454.443l.011.013a.179.179,0,0,1-.011.253l-.651.6a.179.179,0,0,1-.253-.011l-.013-.014q-.237.211-.479.416l.012.015a.179.179,0,0,1-.025.252l-.683.559a.179.179,0,0,1-.252-.025l-.01-.013c-.166.131-.335.259-.5.387l.01.014a.179.179,0,0,1-.04.25l-.715.519a.179.179,0,0,1-.25-.04l-.01-.013c-.174.121-.347.242-.523.36l.008.012a.179.179,0,0,1-.054.248l-.743.477a.179.179,0,0,1-.248-.054l-.008-.012q-.27.167-.544.328l.007.012a.179.179,0,0,1-.068.244l-.769.434a.179.179,0,0,1-.244-.068l-.006-.01q-.279.151-.562.3l.005.01a.179.179,0,0,1-.082.24l-.792.39a.179.179,0,0,1-.24-.082l-.005-.01q-.287.135-.577.265l0,.01a.179.179,0,0,1-.1.235l-.813.344a.179.179,0,0,1-.235-.1l0-.009c-.2.079-.394.155-.592.23l0,.01a.179.179,0,0,1-.109.229l-.832.3a.18.18,0,0,1-.229-.108l0-.009q-.3.1-.6.2l0,.009a.179.179,0,0,1-.121.222l-.847.249a.179.179,0,0,1-.222-.121l0-.011q-.306.083-.614.162l0,.01a.179.179,0,0,1-.134.215l-.86.2a.179.179,0,0,1-.215-.134l0-.012c-.207.044-.415.085-.623.125l0,.013a.179.179,0,0,1-.146.207l-.87.151a.179.179,0,0,1-.207-.146l0-.012c-.209.032-.419.06-.629.088l0,.015a.179.179,0,0,1-.157.2l-.877.1a.179.179,0,0,1-.2-.157l0-.017c-.21.02-.421.039-.633.055v.016a.179.179,0,0,1-.169.189l-.881.05c-.1.005-.131-.088-.136-.186l-.177,0a4.334,4.334,0,0,1-.5.018v.186h-1.273v-.186s-.547-.01-.758-.018l.084,0a.177.177,0,0,1-.169.185l-.864-.05a.172.172,0,0,1-.16-.189l.005-.016c-.211-.016-.42-.035-.63-.055v.017a.178.178,0,0,1-.2.157l-.877-.1a.179.179,0,0,1-.158-.2l0-.015c-.21-.028-.42-.056-.629-.088l0,.012a.179.179,0,0,1-.207.146l-.87-.151a.179.179,0,0,1-.146-.207l0-.013c-.208-.04-.416-.081-.623-.125l0,.012a.179.179,0,0,1-.215.134l-.86-.2a.179.179,0,0,1-.134-.215l0-.01c-.206-.052-.41-.106-.615-.162l0,.011a.179.179,0,0,1-.222.121l-.847-.249a.179.179,0,0,1-.122-.222l0-.009q-.3-.1-.6-.2l0,.009a.179.179,0,0,1-.229.108l-.832-.3a.179.179,0,0,1-.108-.229l0-.01q-.3-.112-.592-.23l0,.009a.179.179,0,0,1-.234.1l-.813-.344a.18.18,0,0,1-.1-.235l0-.01q-.29-.13-.577-.265l-.005.01a.179.179,0,0,1-.24.082l-.792-.39a.179.179,0,0,1-.082-.24l0-.01q-.283-.146-.562-.3l-.006.01a.179.179,0,0,1-.244.068l-.769-.434a.179.179,0,0,1-.068-.244l.007-.012q-.273-.161-.544-.328l-.008.012a.179.179,0,0,1-.247.054l-.743-.477a.179.179,0,0,1-.054-.248l.008-.012c-.176-.118-.35-.238-.523-.36l-.01.013a.179.179,0,0,1-.25.04l-.715-.519a.179.179,0,0,1-.04-.25l.01-.014c-.169-.128-.337-.256-.5-.387l-.01.013a.179.179,0,0,1-.252.025l-.684-.559a.18.18,0,0,1-.025-.252l.012-.014q-.242-.206-.479-.416l-.013.014a.179.179,0,0,1-.253.011l-.651-.6a.179.179,0,0,1-.011-.253l.011-.013c-.153-.146-.3-.295-.454-.443l-.013.013a.179.179,0,0,1-.253,0l-.615-.633a.179.179,0,0,1,0-.253l.014-.013c-.144-.155-.288-.31-.43-.467l-.014.012a.179.179,0,0,1-.253-.018l-.578-.667a.179.179,0,0,1,.018-.253l.014-.012q-.2-.244-.4-.492l-.015.011a.179.179,0,0,1-.251-.033l-.539-.7a.18.18,0,0,1,.033-.251l.013-.01q-.189-.255-.374-.513l-.012.008a.179.179,0,0,1-.249-.047l-.5-.729a.179.179,0,0,1,.047-.249l.013-.009q-.174-.266-.344-.534l-.013.007a.179.179,0,0,1-.246-.061l-.456-.756a.179.179,0,0,1,.061-.246l.01-.006c-.106-.183-.209-.368-.312-.553l-.011.006a.179.179,0,0,1-.242-.075l-.412-.781a.179.179,0,0,1,.075-.242l.01-.005c-.1-.189-.19-.378-.282-.569l-.009,0a.179.179,0,0,1-.238-.089l-.366-.8a.179.179,0,0,1,.088-.237l.01,0q-.127-.291-.248-.585l-.01,0a.179.179,0,0,1-.232-.1l-.32-.823a.179.179,0,0,1,.1-.232l.008,0c-.073-.2-.143-.4-.212-.6l-.01,0a.179.179,0,0,1-.225-.115l-.273-.84a.179.179,0,0,1,.115-.226l.01,0c-.061-.2-.123-.405-.18-.609l-.009,0a.179.179,0,0,1-.219-.128l-.224-.854a.179.179,0,0,1,.128-.219l.011,0q-.074-.309-.143-.619l-.012,0a.179.179,0,0,1-.211-.14l-.175-.865a.179.179,0,0,1,.14-.211l.012,0c-.038-.208-.072-.417-.106-.626l-.014,0a.179.179,0,0,1-.2-.152l-.125-.874a.179.179,0,0,1,.152-.2l.015,0q-.039-.315-.072-.631h-.015a.179.179,0,0,1-.194-.163l-.076-.879a.179.179,0,0,1,.163-.194l.018,0c-.014-.211-.027-.422-.037-.634h-.018a.179.179,0,0,1-.184-.174l-.025-.882a.179.179,0,0,1,.174-.184",
    transform: "translate(-1167.201 -379.396)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29539",
    "data-name": "Path 29539",
    d: "M1531.309,558.6a20.727,20.727,0,1,1,20.727,20.728,20.751,20.751,0,0,1-20.727-20.728m.391,0a20.336,20.336,0,1,0,20.337-20.336A20.359,20.359,0,0,0,1531.7,558.6",
    transform: "translate(-1214.79 -426.698)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29540",
    "data-name": "Path 29540",
    d: "M1558.125,545.55a19.141,19.141,0,1,0,19.141,19.141,19.141,19.141,0,0,0-19.141-19.141",
    transform: "translate(-1220.878 -432.786)",
    fill: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10949",
    "data-name": "Group 10949",
    transform: "translate(310.41 105.069)",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10948",
    "data-name": "Group 10948"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10947",
    "data-name": "Group 10947",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29541",
    "data-name": "Path 29541",
    d: "M1501.753,535.157a26.837,26.837,0,1,1,26.837,26.836,26.867,26.867,0,0,1-26.837-26.836m.506,0a26.33,26.33,0,1,0,26.33-26.33,26.36,26.36,0,0,0-26.33,26.33",
    transform: "translate(-1501.753 -508.32)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_29542",
    "data-name": "Path 29542",
    d: "M1564.237,553.255a17.549,17.549,0,1,0,17.548,17.549,17.549,17.549,0,0,0-17.548-17.549",
    transform: "translate(-1226.99 -438.898)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29543",
    "data-name": "Path 29543",
    d: "M1613.679,551.938a13.658,13.658,0,0,1,3.522.851,10.315,10.315,0,0,1-.579-2.912v-6.988a9.74,9.74,0,0,0-4.455-1.043,9.575,9.575,0,0,0-4.455,1.043v6.988a10.188,10.188,0,0,1-.477,2.912,14.049,14.049,0,0,1,3.771-.87c.471-2.427,1.168-6.048,1.168-6.048Z",
    transform: "translate(-1275.022 -429.847)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29544",
    "data-name": "Path 29544",
    d: "M1552.571,580.138a14.046,14.046,0,0,1,2.525-2.671,10.241,10.241,0,0,1-2.784-1l-6.052-3.494a10.24,10.24,0,0,0-3.154,3.377,10.015,10.015,0,0,0-1.347,4.42l6.052,3.494a10.187,10.187,0,0,1,2.279,1.876,14.03,14.03,0,0,1,1.13-3.7c-1.866-1.622-4.654-4.034-4.654-4.034Z",
    transform: "translate(-1223.08 -454.539)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29545",
    "data-name": "Path 29545",
    d: "M1550.665,641.017a14.055,14.055,0,0,1-1.051-3.523,10.237,10.237,0,0,1-2.26,1.91L1541.3,642.9a10.239,10.239,0,0,0,1.347,4.42,10.011,10.011,0,0,0,3.154,3.377l6.052-3.494a10.188,10.188,0,0,1,2.764-1.036,14.025,14.025,0,0,1-2.637-2.827c-2.337.805-5.821,2.014-5.821,2.014Z",
    transform: "translate(-1222.717 -505.725)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29546",
    "data-name": "Path 29546",
    d: "M1609.588,681.183a14.363,14.363,0,0,1-3.617-.851,10.187,10.187,0,0,1,.484,2.912v6.988a9.741,9.741,0,0,0,4.455,1.044,9.574,9.574,0,0,0,4.455-1.044v-6.988a10.293,10.293,0,0,1,.572-2.912,13.712,13.712,0,0,1-3.723.87c-.471,2.427-1.145,6.048-1.145,6.048Z",
    transform: "translate(-1274.019 -539.708)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29547",
    "data-name": "Path 29547",
    d: "M1658.039,644.589a14.367,14.367,0,0,1-2.546,2.708,10.189,10.189,0,0,1,2.763,1.038l6.052,3.494a10.24,10.24,0,0,0,3.154-3.377,10.012,10.012,0,0,0,1.347-4.42l-6.052-3.494a10.249,10.249,0,0,1-2.258-1.912,13.88,13.88,0,0,1-1.119,3.679c1.866,1.622,4.66,4.025,4.66,4.025Z",
    transform: "translate(-1313.305 -506.623)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29548",
    "data-name": "Path 29548",
    d: "M1660.182,583.721a14.386,14.386,0,0,1,1.072,3.559,10.189,10.189,0,0,1,2.281-1.873l6.052-3.494a10.24,10.24,0,0,0-1.347-4.42,10.014,10.014,0,0,0-3.154-3.377l-6.052,3.494a10.247,10.247,0,0,1-2.785,1,13.878,13.878,0,0,1,2.626,2.809c2.337-.805,5.815-2.023,5.815-2.023Z",
    transform: "translate(-1313.903 -455.446)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29549",
    "data-name": "Path 29549",
    d: "M1548.153,532.982a21.739,21.739,0,1,0,21.739,21.739,21.739,21.739,0,0,0-21.739-21.739m0,40.88a19.141,19.141,0,1,1,19.141-19.141,19.141,19.141,0,0,1-19.141,19.141",
    transform: "translate(-1210.907 -422.815)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29550",
    "data-name": "Path 29550",
    d: "M1581.147,598.35a10.333,10.333,0,1,1,10.333,10.333,10.333,10.333,0,0,1-10.333-10.333",
    transform: "translate(-1254.326 -466.475)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29551",
    "data-name": "Path 29551",
    d: "M1623.455,631.913a1.588,1.588,0,1,1,1.588,1.588,1.588,1.588,0,0,1-1.588-1.588",
    transform: "translate(-1287.889 -500.038)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29552",
    "data-name": "Path 29552",
    d: "M1627.013,603.371a.853.853,0,1,1,.853.852.853.853,0,0,1-.853-.852",
    transform: "translate(-1290.712 -477.979)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29553",
    "data-name": "Path 29553",
    d: "M1600.388,619.752a.853.853,0,1,1,1.165-.312.852.852,0,0,1-1.165.312",
    transform: "translate(-1269.252 -490.388)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29554",
    "data-name": "Path 29554",
    d: "M1601.264,651a.853.853,0,1,1,.312-1.165.853.853,0,0,1-.312,1.165",
    transform: "translate(-1269.27 -515.177)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29555",
    "data-name": "Path 29555",
    d: "M1628.762,665.866a.853.853,0,1,1-.852-.852.853.853,0,0,1,.852.852",
    transform: "translate(-1290.747 -527.557)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29556",
    "data-name": "Path 29556",
    d: "M1655.386,649.485a.852.852,0,1,1-1.165.312.852.852,0,0,1,1.165-.312",
    transform: "translate(-1312.205 -515.147)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29557",
    "data-name": "Path 29557",
    d: "M1654.511,618.237a.852.852,0,1,1-.312,1.164.852.852,0,0,1,.312-1.164",
    transform: "translate(-1312.187 -490.358)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29558",
    "data-name": "Path 29558",
    d: "M254.888,470.029H170.149v-4.747a36.4,36.4,0,0,1,36.395-36.395h11.949a36.4,36.4,0,0,1,36.395,36.395Z",
    transform: "translate(-134.979 -340.237)",
    fill: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29559",
    "data-name": "Path 29559",
    d: "M220.845,511.589h.019c0-.106,0-.211,0-.317s0-.212,0-.318h-.019a.179.179,0,0,1-.174-.184l.025-.883a.179.179,0,0,1,.184-.174h.018c.01-.212.023-.423.037-.634l-.018,0a.179.179,0,0,1-.163-.194l.076-.88a.179.179,0,0,1,.194-.163h.015q.033-.317.072-.631l-.015,0a.179.179,0,0,1-.152-.2l.126-.874a.179.179,0,0,1,.2-.152l.014,0c.034-.209.069-.418.106-.626l-.012,0a.179.179,0,0,1-.14-.211l.175-.865a.179.179,0,0,1,.211-.14l.012,0q.069-.311.143-.619l-.012,0a.179.179,0,0,1-.128-.219l.224-.854a.179.179,0,0,1,.219-.128l.009,0c.058-.2.119-.407.18-.609l-.01,0a.179.179,0,0,1-.115-.226l.273-.84a.179.179,0,0,1,.226-.115l.01,0c.069-.2.139-.4.212-.6l-.008,0a.179.179,0,0,1-.1-.232l.32-.823a.179.179,0,0,1,.232-.1l.01,0q.121-.294.248-.585l-.01,0a.179.179,0,0,1-.088-.237l.367-.8a.179.179,0,0,1,.237-.089l.009,0c.092-.191.187-.38.282-.569l-.01-.005a.179.179,0,0,1-.075-.242l.412-.781a.179.179,0,0,1,.242-.075l.012.006c.1-.185.206-.37.312-.553l-.011-.006a.179.179,0,0,1-.061-.246l.456-.756a.179.179,0,0,1,.246-.061l.013.008q.169-.269.344-.534l-.013-.009a.179.179,0,0,1-.047-.249l.5-.729a.179.179,0,0,1,.249-.047l.012.008q.184-.259.374-.513l-.013-.01a.179.179,0,0,1-.032-.251l.539-.7a.179.179,0,0,1,.251-.032l.014.011q.2-.247.4-.492l-.014-.012a.179.179,0,0,1-.018-.253l.578-.667a.179.179,0,0,1,.253-.018l.014.012q.212-.236.43-.467l-.014-.013a.179.179,0,0,1,0-.253l.615-.633a.179.179,0,0,1,.253,0l.013.013c.15-.149.3-.3.454-.443l-.012-.013a.179.179,0,0,1,.011-.253l.65-.6a.179.179,0,0,1,.253.011l.013.014q.238-.21.48-.416l-.012-.014a.179.179,0,0,1,.025-.252l.684-.559a.179.179,0,0,1,.252.025l.01.012c.166-.131.334-.259.5-.387l-.01-.014a.179.179,0,0,1,.04-.25l.714-.519a.179.179,0,0,1,.25.04l.01.013c.173-.121.347-.242.523-.36l-.008-.012a.179.179,0,0,1,.054-.248l.743-.477a.179.179,0,0,1,.248.054l.008.012q.27-.167.544-.328l-.007-.012a.179.179,0,0,1,.068-.244l.769-.434a.179.179,0,0,1,.244.068l.006.01q.279-.151.562-.3l0-.01a.179.179,0,0,1,.082-.24l.792-.39a.179.179,0,0,1,.24.082l.005.01q.287-.135.577-.265l0-.009a.179.179,0,0,1,.1-.235l.813-.344a.179.179,0,0,1,.235.1l0,.009q.295-.118.592-.23l0-.01a.179.179,0,0,1,.109-.229l.832-.3a.179.179,0,0,1,.229.109l0,.008q.3-.1.6-.2l0-.009a.179.179,0,0,1,.121-.222l.847-.249a.179.179,0,0,1,.222.121l0,.011q.306-.083.614-.162l0-.011a.179.179,0,0,1,.134-.215l.86-.2a.179.179,0,0,1,.215.134l0,.012c.207-.044.414-.085.623-.125l0-.013a.179.179,0,0,1,.146-.207l.87-.151a.179.179,0,0,1,.207.146l0,.012c.209-.032.419-.06.629-.088l0-.015a.179.179,0,0,1,.158-.2l.877-.1a.179.179,0,0,1,.2.157l0,.017c.21-.02.421-.04.633-.055V478.5a.179.179,0,0,1,.169-.189l.881-.05a.179.179,0,0,1,.189.168s.5,0,.5,0l.039-.019c0-.1-.015-.166.084-.166h1.037c.1,0,.03.067.03.166l.016.019c.509,0,.8,0,.8,0,.006-.1,0-.174.1-.168l1.048.05c.1.006.05.09.05.189v.016c0,.016.555.035.766.055l-.041-.017a.16.16,0,0,1,.177-.157l.866.1a.175.175,0,0,1,.152.2l0,.015c.21.028.419.056.628.088v-.013a.179.179,0,0,1,.207-.146l.87.151a.179.179,0,0,1,.146.207l0,.013c.208.04.416.081.623.125l0-.012a.179.179,0,0,1,.215-.134l.86.2a.179.179,0,0,1,.134.215l0,.011c.206.052.41.106.614.162l0-.011a.179.179,0,0,1,.222-.121l.847.249a.179.179,0,0,1,.121.222l0,.009q.3.1.6.2l0-.008a.18.18,0,0,1,.229-.109l.832.3a.179.179,0,0,1,.108.229l0,.01c.2.075.4.151.592.23l0-.009a.179.179,0,0,1,.235-.1l.813.344a.179.179,0,0,1,.1.235l0,.009q.291.13.578.265l0-.01a.179.179,0,0,1,.24-.082l.792.39a.179.179,0,0,1,.082.24l0,.01q.282.146.562.3l.006-.01a.179.179,0,0,1,.244-.068l.769.434a.179.179,0,0,1,.068.244l-.007.012q.273.162.544.328l.008-.012a.179.179,0,0,1,.248-.054l.743.477a.18.18,0,0,1,.054.248l-.008.012c.176.118.35.239.523.36l.01-.013a.179.179,0,0,1,.25-.04l.714.519a.179.179,0,0,1,.04.25l-.01.014c.169.128.337.256.5.387l.01-.012a.179.179,0,0,1,.252-.025l.684.559a.179.179,0,0,1,.025.252l-.012.015q.242.206.48.416l.013-.014a.179.179,0,0,1,.253-.011l.65.6a.179.179,0,0,1,.011.253l-.012.013c.153.146.3.295.454.443l.013-.013a.18.18,0,0,1,.253,0l.615.633a.179.179,0,0,1,0,.253l-.014.013q.217.232.43.467l.014-.012a.179.179,0,0,1,.253.018l.578.667a.179.179,0,0,1-.018.253l-.013.012q.2.244.4.492l.014-.011a.179.179,0,0,1,.251.032l.539.7a.179.179,0,0,1-.032.251l-.013.01q.189.255.374.513l.012-.008a.179.179,0,0,1,.249.047l.5.729a.179.179,0,0,1-.047.249l-.013.009q.174.265.344.534l.013-.008a.179.179,0,0,1,.246.061l.456.756a.179.179,0,0,1-.061.246l-.011.006c.106.183.209.368.312.553l.012-.006a.179.179,0,0,1,.242.075l.412.781a.179.179,0,0,1-.075.242l-.01.005c.1.189.19.378.282.569l.009,0a.179.179,0,0,1,.237.089l.367.8a.179.179,0,0,1-.088.237l-.01,0q.126.291.247.585l.01,0a.179.179,0,0,1,.232.1l.32.823a.179.179,0,0,1-.1.232l-.008,0c.073.2.143.4.212.6l.009,0a.179.179,0,0,1,.226.115l.273.84a.179.179,0,0,1-.115.226l-.01,0c.062.2.123.405.18.609l.009,0a.179.179,0,0,1,.219.128l.225.854a.179.179,0,0,1-.128.219l-.012,0q.075.308.143.619l.012,0a.179.179,0,0,1,.211.14l.175.865a.179.179,0,0,1-.14.211l-.012,0c.038.208.073.417.106.626l.014,0a.179.179,0,0,1,.2.152l.125.874a.179.179,0,0,1-.152.2l-.015,0c.026.21.05.42.072.631h.015a.179.179,0,0,1,.194.163l.076.88a.179.179,0,0,1-.163.194l-.018,0c.014.211.027.422.037.634h.018a.179.179,0,0,1,.184.174l.025.883a.179.179,0,0,1-.174.184h-.02c0,.106,0,.211,0,.317s0,.211,0,.317h.02a.179.179,0,0,1,.174.184l-.025.882a.179.179,0,0,1-.184.174h-.018c-.01.212-.023.423-.037.634l.018,0a.179.179,0,0,1,.163.194l-.076.88a.179.179,0,0,1-.194.163h-.015c-.022.211-.046.421-.072.631l.015,0a.179.179,0,0,1,.152.2l-.125.874a.179.179,0,0,1-.2.152l-.014,0c-.034.209-.068.418-.106.626l.012,0a.179.179,0,0,1,.14.211l-.175.865a.179.179,0,0,1-.211.14l-.012,0q-.069.311-.143.619l.012,0a.179.179,0,0,1,.128.219l-.225.854a.179.179,0,0,1-.219.128l-.009,0c-.058.2-.119.407-.18.609l.01,0a.179.179,0,0,1,.115.226l-.273.84a.179.179,0,0,1-.226.115l-.009,0c-.069.2-.139.4-.212.6l.008,0a.179.179,0,0,1,.1.232l-.32.823a.179.179,0,0,1-.232.1l-.01,0q-.121.294-.247.585l.01,0a.179.179,0,0,1,.088.237l-.367.8a.179.179,0,0,1-.237.089l-.009,0c-.092.191-.187.38-.282.569l.01.006a.179.179,0,0,1,.075.242l-.412.781a.179.179,0,0,1-.242.075l-.012-.006c-.1.185-.206.37-.312.553l.011.006a.179.179,0,0,1,.061.246l-.456.756a.179.179,0,0,1-.246.061l-.013-.007q-.169.268-.344.534l.013.009a.179.179,0,0,1,.047.249l-.5.729a.179.179,0,0,1-.249.047l-.012-.008q-.185.259-.374.513l.013.01a.179.179,0,0,1,.032.251l-.539.7a.179.179,0,0,1-.251.033l-.014-.011q-.2.247-.4.492l.013.012a.179.179,0,0,1,.018.253l-.578.667a.179.179,0,0,1-.253.018l-.014-.012c-.142.157-.285.313-.43.467l.014.013a.179.179,0,0,1,0,.253l-.615.633a.179.179,0,0,1-.253,0l-.013-.013c-.15.149-.3.3-.454.443l.012.013a.179.179,0,0,1-.011.253l-.65.6a.179.179,0,0,1-.253-.011l-.013-.014q-.238.211-.48.416l.012.015a.179.179,0,0,1-.025.252l-.683.559a.179.179,0,0,1-.252-.025l-.01-.013c-.166.131-.334.259-.5.387l.01.014a.179.179,0,0,1-.039.25l-.714.519a.179.179,0,0,1-.25-.04l-.01-.013c-.173.121-.347.242-.523.36l.008.012a.179.179,0,0,1-.054.248l-.743.477a.179.179,0,0,1-.248-.054l-.008-.012q-.27.167-.544.328l.007.012a.179.179,0,0,1-.068.244l-.769.434a.179.179,0,0,1-.244-.068l-.006-.01q-.279.151-.562.3l0,.01a.179.179,0,0,1-.082.24l-.792.39a.179.179,0,0,1-.24-.082l0-.01q-.287.135-.578.265l0,.01a.179.179,0,0,1-.1.235l-.813.344a.179.179,0,0,1-.235-.1l0-.009q-.294.118-.592.23l0,.01a.179.179,0,0,1-.108.229l-.832.3a.179.179,0,0,1-.229-.108l0-.009q-.3.1-.6.2l0,.009a.179.179,0,0,1-.121.222l-.847.249a.179.179,0,0,1-.222-.121l0-.011q-.306.083-.614.162l0,.01a.179.179,0,0,1-.134.215l-.86.2a.179.179,0,0,1-.215-.134l0-.012c-.207.044-.415.085-.623.125l0,.013a.179.179,0,0,1-.146.207l-.87.151a.179.179,0,0,1-.207-.146l0-.012c-.209.032-.419.06-.629.088l0,.015a.179.179,0,0,1-.158.2l-.877.1a.179.179,0,0,1-.2-.157l0-.017c-.21.02-.421.039-.633.055v.016a.179.179,0,0,1-.169.189l-.882.05c-.1.005-.13-.088-.136-.186l-.178,0a4.328,4.328,0,0,1-.5.018v.186h-1.273v-.186s-.547-.01-.758-.018l.084,0a.177.177,0,0,1-.169.185l-.864-.05a.172.172,0,0,1-.16-.189l.005-.016c-.211-.016-.42-.035-.63-.055v.017a.179.179,0,0,1-.2.157l-.877-.1a.179.179,0,0,1-.157-.2l0-.015c-.21-.028-.42-.056-.629-.088l0,.012a.179.179,0,0,1-.207.146l-.87-.151a.179.179,0,0,1-.146-.207l0-.013c-.208-.04-.416-.081-.623-.125l0,.012a.179.179,0,0,1-.215.134l-.86-.2a.179.179,0,0,1-.134-.215l0-.01q-.309-.078-.614-.162l0,.011a.179.179,0,0,1-.222.121l-.847-.249a.179.179,0,0,1-.121-.222l0-.009q-.3-.1-.6-.2l0,.009a.179.179,0,0,1-.229.108l-.832-.3a.179.179,0,0,1-.109-.229l0-.01q-.3-.112-.592-.23l0,.009a.179.179,0,0,1-.235.1l-.813-.344a.179.179,0,0,1-.1-.235l0-.01q-.29-.13-.577-.265l-.005.01a.179.179,0,0,1-.24.082l-.792-.39a.179.179,0,0,1-.082-.24l0-.01q-.282-.146-.562-.3l-.006.01a.179.179,0,0,1-.244.068l-.769-.434a.179.179,0,0,1-.068-.244l.007-.012q-.273-.161-.544-.328l-.008.012a.179.179,0,0,1-.247.054l-.743-.477a.179.179,0,0,1-.054-.248l.008-.012c-.176-.118-.35-.238-.523-.36l-.01.013a.179.179,0,0,1-.25.04l-.714-.519a.179.179,0,0,1-.04-.25l.01-.014c-.169-.128-.337-.256-.5-.387l-.01.013a.179.179,0,0,1-.252.025l-.684-.559a.179.179,0,0,1-.025-.252l.012-.014q-.242-.206-.48-.416l-.013.014a.179.179,0,0,1-.253.011l-.65-.6a.179.179,0,0,1-.011-.253l.012-.013c-.153-.146-.3-.295-.454-.443l-.013.013a.179.179,0,0,1-.253,0l-.615-.633a.179.179,0,0,1,0-.253l.014-.013c-.145-.155-.288-.31-.43-.467l-.014.012a.179.179,0,0,1-.253-.018l-.578-.667a.179.179,0,0,1,.018-.253l.014-.012q-.2-.244-.4-.492l-.014.011a.179.179,0,0,1-.251-.033l-.539-.7a.179.179,0,0,1,.032-.251l.013-.01q-.189-.255-.374-.513l-.012.008a.179.179,0,0,1-.249-.047l-.5-.729a.179.179,0,0,1,.047-.249l.013-.009q-.175-.266-.344-.534l-.013.007a.179.179,0,0,1-.246-.061l-.456-.756a.179.179,0,0,1,.061-.246l.011-.006c-.106-.183-.209-.368-.312-.553l-.012.006a.179.179,0,0,1-.242-.075l-.412-.781a.179.179,0,0,1,.075-.242l.011-.005c-.1-.189-.19-.378-.282-.569l-.009,0a.179.179,0,0,1-.237-.089l-.367-.8a.179.179,0,0,1,.088-.237l.01,0q-.127-.291-.248-.585l-.01,0a.179.179,0,0,1-.232-.1l-.32-.823a.179.179,0,0,1,.1-.232l.008,0c-.073-.2-.143-.4-.212-.6l-.01,0a.179.179,0,0,1-.226-.115l-.273-.84a.179.179,0,0,1,.115-.226l.01,0c-.062-.2-.122-.405-.18-.609l-.009,0a.179.179,0,0,1-.219-.128l-.224-.854a.179.179,0,0,1,.128-.219l.012,0q-.075-.309-.143-.619l-.012,0a.179.179,0,0,1-.211-.14l-.175-.865a.179.179,0,0,1,.14-.211l.012,0c-.038-.208-.072-.417-.106-.626l-.014,0a.179.179,0,0,1-.2-.152l-.126-.874a.179.179,0,0,1,.152-.2l.015,0q-.039-.315-.072-.631h-.015a.179.179,0,0,1-.194-.163l-.075-.879a.179.179,0,0,1,.163-.194l.018,0c-.014-.211-.027-.422-.037-.634h-.018a.179.179,0,0,1-.184-.174l-.025-.882a.179.179,0,0,1,.174-.184",
    transform: "translate(-175.058 -379.396)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29560",
    "data-name": "Path 29560",
    d: "M280.659,558.6a20.727,20.727,0,1,1,20.728,20.728A20.751,20.751,0,0,1,280.659,558.6m.391,0a20.336,20.336,0,1,0,20.336-20.336A20.359,20.359,0,0,0,281.05,558.6",
    transform: "translate(-222.647 -426.698)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29561",
    "data-name": "Path 29561",
    d: "M307.475,545.55a19.141,19.141,0,1,0,19.141,19.141,19.141,19.141,0,0,0-19.141-19.141",
    transform: "translate(-228.736 -432.786)",
    fill: "#2e2e2e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10952",
    "data-name": "Group 10952",
    transform: "translate(51.903 105.069)",
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10951",
    "data-name": "Group 10951"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10950",
    "data-name": "Group 10950",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29562",
    "data-name": "Path 29562",
    d: "M251.1,535.157a26.837,26.837,0,1,1,26.837,26.836A26.867,26.867,0,0,1,251.1,535.157m.506,0a26.33,26.33,0,1,0,26.33-26.33,26.36,26.36,0,0,0-26.33,26.33",
    transform: "translate(-251.103 -508.32)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_29563",
    "data-name": "Path 29563",
    d: "M313.588,553.255A17.549,17.549,0,1,0,331.136,570.8a17.549,17.549,0,0,0-17.549-17.549",
    transform: "translate(-234.848 -438.898)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29564",
    "data-name": "Path 29564",
    d: "M363.029,551.938a13.655,13.655,0,0,1,3.522.851,10.309,10.309,0,0,1-.578-2.912v-6.988a9.742,9.742,0,0,0-4.455-1.043,9.575,9.575,0,0,0-4.455,1.043v6.988a10.183,10.183,0,0,1-.477,2.912,14.051,14.051,0,0,1,3.771-.87c.471-2.427,1.168-6.048,1.168-6.048Z",
    transform: "translate(-282.879 -429.847)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29565",
    "data-name": "Path 29565",
    d: "M301.922,580.138a14.05,14.05,0,0,1,2.525-2.671,10.242,10.242,0,0,1-2.784-1l-6.052-3.494a10.241,10.241,0,0,0-3.154,3.377,10.016,10.016,0,0,0-1.347,4.42l6.052,3.494a10.186,10.186,0,0,1,2.279,1.876,14.022,14.022,0,0,1,1.13-3.7c-1.866-1.622-4.655-4.034-4.655-4.034Z",
    transform: "translate(-230.938 -454.539)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29566",
    "data-name": "Path 29566",
    d: "M300.015,641.017a14.061,14.061,0,0,1-1.051-3.523,10.237,10.237,0,0,1-2.259,1.91l-6.052,3.494a10.241,10.241,0,0,0,1.347,4.42,10.013,10.013,0,0,0,3.154,3.377l6.052-3.494a10.188,10.188,0,0,1,2.764-1.036,14.021,14.021,0,0,1-2.637-2.827c-2.337.805-5.821,2.014-5.821,2.014Z",
    transform: "translate(-230.575 -505.725)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29567",
    "data-name": "Path 29567",
    d: "M358.938,681.183a14.364,14.364,0,0,1-3.617-.851,10.191,10.191,0,0,1,.484,2.912v6.988a9.74,9.74,0,0,0,4.455,1.044,9.574,9.574,0,0,0,4.455-1.044v-6.988a10.293,10.293,0,0,1,.572-2.912,13.712,13.712,0,0,1-3.723.87c-.471,2.427-1.145,6.048-1.145,6.048Z",
    transform: "translate(-281.877 -539.708)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29568",
    "data-name": "Path 29568",
    d: "M407.39,644.589a14.361,14.361,0,0,1-2.546,2.708,10.189,10.189,0,0,1,2.763,1.038l6.052,3.494a10.24,10.24,0,0,0,3.154-3.377,10.01,10.01,0,0,0,1.347-4.42l-6.052-3.494a10.245,10.245,0,0,1-2.258-1.912,13.875,13.875,0,0,1-1.119,3.679c1.866,1.622,4.66,4.025,4.66,4.025Z",
    transform: "translate(-321.163 -506.623)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29569",
    "data-name": "Path 29569",
    d: "M409.533,583.721a14.367,14.367,0,0,1,1.072,3.559,10.182,10.182,0,0,1,2.28-1.873l6.052-3.494a10.241,10.241,0,0,0-1.347-4.42,10.013,10.013,0,0,0-3.154-3.377l-6.052,3.494a10.244,10.244,0,0,1-2.785,1,13.883,13.883,0,0,1,2.626,2.809c2.337-.805,5.815-2.023,5.815-2.023Z",
    transform: "translate(-321.762 -455.446)",
    fill: "#d9d9d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29570",
    "data-name": "Path 29570",
    d: "M297.5,532.982a21.739,21.739,0,1,0,21.739,21.739A21.739,21.739,0,0,0,297.5,532.982m0,40.88a19.141,19.141,0,1,1,19.141-19.141A19.141,19.141,0,0,1,297.5,573.862",
    transform: "translate(-218.765 -422.815)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29571",
    "data-name": "Path 29571",
    d: "M330.5,598.35a10.333,10.333,0,1,1,10.333,10.333A10.333,10.333,0,0,1,330.5,598.35",
    transform: "translate(-262.184 -466.475)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29572",
    "data-name": "Path 29572",
    d: "M372.8,631.913a1.588,1.588,0,1,1,1.588,1.588,1.588,1.588,0,0,1-1.588-1.588",
    transform: "translate(-295.747 -500.038)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29573",
    "data-name": "Path 29573",
    d: "M376.363,603.371a.853.853,0,1,1,.852.852.852.852,0,0,1-.852-.852",
    transform: "translate(-298.569 -477.979)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29574",
    "data-name": "Path 29574",
    d: "M349.738,619.752a.853.853,0,1,1,1.165-.312.853.853,0,0,1-1.165.312",
    transform: "translate(-277.11 -490.388)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29575",
    "data-name": "Path 29575",
    d: "M350.614,651a.853.853,0,1,1,.312-1.165.853.853,0,0,1-.312,1.165",
    transform: "translate(-277.128 -515.177)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29576",
    "data-name": "Path 29576",
    d: "M378.112,665.866a.853.853,0,1,1-.852-.852.853.853,0,0,1,.852.852",
    transform: "translate(-298.604 -527.557)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29577",
    "data-name": "Path 29577",
    d: "M404.736,649.485a.852.852,0,1,1-1.164.312.852.852,0,0,1,1.164-.312",
    transform: "translate(-320.063 -515.147)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29578",
    "data-name": "Path 29578",
    d: "M403.862,618.237a.852.852,0,1,1-.312,1.164.853.853,0,0,1,.312-1.164",
    transform: "translate(-320.046 -490.358)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29579",
    "data-name": "Path 29579",
    d: "M391.953,106.5c0-.164,0-.328-.005-.491,0-.143-.006-.284-.009-.425s-.008-.312-.014-.466-.011-.288-.018-.431-.014-.3-.022-.443-.016-.289-.025-.433-.019-.28-.029-.419-.021-.293-.033-.438-.022-.261-.034-.391c-.013-.149-.027-.3-.042-.446-.012-.12-.025-.237-.037-.356-.017-.155-.033-.31-.051-.463-.012-.1-.025-.205-.038-.308-.02-.164-.04-.328-.062-.489-.01-.075-.021-.148-.031-.222-.172-1.237-.382-2.4-.613-3.478a18.953,18.953,0,0,0-4.2-8.389l-8.269-13.635c-.01-.056-.018-.111-.029-.167l-.207-.221-7.3-8.848c-.027.3-.06.611-.1.93L358.208,53.015a10.335,10.335,0,0,1-2.834-7.087V25.993a8.494,8.494,0,0,1-.929-4.268l.568-12.22a2.35,2.35,0,0,0-2.053-2.442C329.742,4.147,305.293,1.907,278.483.788,259.768.007,241.852-.159,224.821.14a188.96,188.96,0,0,0-28.743,2.673,156.119,156.119,0,0,0-37.632,11.07c-22.778,10.175-32.2,15.532-47.358,24.679L98.481,45.513a29.221,29.221,0,0,1-7.5,2.8l-35.516,7.93A74.489,74.489,0,0,0,27.646,68.748q-.438.321-.878.652-1.837,1.384-3.5,2.792A69.732,69.732,0,0,0,5.764,94.768l-4.155,8.473a15.748,15.748,0,0,0-.846,11.778l4.651,14.393a16.767,16.767,0,0,0,1.124,2.661c-.963.136-1.9.244-2.821.338a2.534,2.534,0,0,0-1.433,4.41,14.139,14.139,0,0,0,8.471,3.563l29.654,2h.242l.031,0v0h2.766c-2.62-8.8-2.05-18.975,3.158-29.21a30.582,30.582,0,0,1,13.634-13.54c27.745-13.8,55.217,6.015,55.217,32.246a36.762,36.762,0,0,1-1.525,10.5h11.5l-.01-.028H301.964c-2.616-8.815-2.034-19.006,3.2-29.252A30.723,30.723,0,0,1,318.944,99.54c27.684-13.628,55.038,6.16,55.038,32.335q0,.921-.046,1.832l4.218-.632h0a12.044,12.044,0,0,0,3.769-1.03,11.853,11.853,0,0,0,5.9-5.94,47.454,47.454,0,0,0,3.965-15.374q.041-.493.071-.978c.007-.109.011-.217.017-.326.012-.213.024-.426.033-.636.006-.13.009-.258.013-.386.006-.187.013-.374.017-.56,0-.138,0-.274.006-.411,0-.173,0-.346.005-.517,0-.141,0-.281,0-.421M307.691,37.342a1.941,1.941,0,0,1-1.786,1.909L241.628,44.4a53.053,53.053,0,0,0-5.27.637l-52.385,8.878a55.761,55.761,0,0,1-15.65.423L134.96,50.529a2.207,2.207,0,0,1-1.913-2.654l1.229-5.758a9.6,9.6,0,0,1,4.35-6.172c1.549-.955,3.67-2.222,6.474-3.823A208.119,208.119,0,0,1,168.98,20.168C195,9.459,224.72,8.85,242.767,9.375c10.469.2,21.515.722,33.072,1.685,12.821,1.068,25.918,2.911,30.471,3.579a1.94,1.94,0,0,1,1.658,1.946Z",
    transform: "translate(0 -0.001)",
    fill: "#cc333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29580",
    "data-name": "Path 29580",
    d: "M661.557,475.931H506.976l-4.955-11.678H661.557a5.839,5.839,0,1,1,0,11.678",
    transform: "translate(-398.254 -368.293)",
    fill: "#e03843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29581",
    "data-name": "Path 29581",
    d: "M1467.993,423.915a42.584,42.584,0,0,1,42.568,41.4h.006c.006-.3.011-.608.011-.913a42.585,42.585,0,0,0-85.169,0c0,.325.008.648.015.971a42.585,42.585,0,0,1,42.569-41.452",
    transform: "translate(-1130.779 -334.624)",
    fill: "#e03843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29582",
    "data-name": "Path 29582",
    d: "M98.035,500.754l-6.249,2.587a6.561,6.561,0,0,0-3.975,5.064l-2.074,13.484a2.981,2.981,0,0,0,4.128,3.191l4.235-1.828a6.874,6.874,0,0,0,4.061-5.209l2.475-15.229a1.9,1.9,0,0,0-2.6-2.06",
    transform: "translate(-67.987 -397.132)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29583",
    "data-name": "Path 29583",
    d: "M107.305,500.754l-6.248,2.587a6.56,6.56,0,0,0-3.67,3.861,6.554,6.554,0,0,1,1.488-.86l6.248-2.587a1.9,1.9,0,0,1,2.6,2.06l-2.475,15.229a6.866,6.866,0,0,1-.341,1.288,6.873,6.873,0,0,0,2.523-4.289l2.475-15.229a1.9,1.9,0,0,0-2.6-2.06",
    transform: "translate(-77.257 -397.132)",
    fill: "#474447"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29584",
    "data-name": "Path 29584",
    d: "M743.161,45.508c-14.453-2.539-30.111-4.673-46.862-6.1-12.2-1.039-23.866-1.607-34.92-1.819-19.055-.566-50.433.091-77.91,11.65a217.876,217.876,0,0,0-25.214,12.9c-7.752,4.522-19.489,11.889-31.312,20.133a2.225,2.225,0,0,0-.1,3.572c.853.674,1.766,1.343,2.744,2a43.752,43.752,0,0,0,9.243,4.7,28.575,28.575,0,0,0,14.611,1.332L654.613,76.088a54.817,54.817,0,0,1,5.563-.687l67.848-4.881a15.305,15.305,0,0,0,11.5-6.5,43.007,43.007,0,0,0,6.416-14.226,3.494,3.494,0,0,0-2.781-4.284m-18.2,21.543a1.942,1.942,0,0,1-1.786,1.909L658.9,74.113a53.051,53.051,0,0,0-5.271.637l-52.384,8.878a55.761,55.761,0,0,1-15.65.423L552.23,80.238a2.207,2.207,0,0,1-1.913-2.654l1.229-5.758a9.6,9.6,0,0,1,4.35-6.172c1.549-.955,3.669-2.222,6.474-3.823A208.136,208.136,0,0,1,586.25,49.877c26.023-10.709,55.74-11.318,73.787-10.793,10.469.2,21.515.722,33.072,1.685,12.821,1.068,25.919,2.911,30.472,3.579a1.939,1.939,0,0,1,1.658,1.946Z",
    transform: "translate(-417.27 -29.71)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10955",
    "data-name": "Group 10955",
    transform: "translate(132.998 9.245)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10954",
    "data-name": "Group 10954"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10953",
    "data-name": "Group 10953",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29585",
    "data-name": "Path 29585",
    d: "M816.753,50.119c-4.553-.668-17.651-2.511-30.472-3.579-11.557-.963-22.6-1.489-33.072-1.685-18.047-.525-47.764.084-73.787,10.793A208.121,208.121,0,0,0,655.542,67.6c-2.805,1.6-4.925,2.868-6.474,3.823a9.6,9.6,0,0,0-4.35,6.172l-1.229,5.759a2.207,2.207,0,0,0,1.913,2.654l33.364,3.813a55.761,55.761,0,0,0,15.65-.423L746.8,80.521a52.988,52.988,0,0,1,5.271-.637l64.277-5.153a1.941,1.941,0,0,0,1.786-1.909l.277-20.757a1.939,1.939,0,0,0-1.657-1.946",
    transform: "translate(-643.44 -44.725)",
    fill: "#63aab6"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_29586",
    "data-name": "Path 29586",
    d: "M1725.548,144.592a24.622,24.622,0,0,1,7.523,2.574c.143.076.3.156.435.234a114.189,114.189,0,0,0-9.714-13.663v8.887a2.073,2.073,0,0,0,1.756,1.969",
    transform: "translate(-1367.487 -106.093)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29587",
    "data-name": "Path 29587",
    d: "M1529.211,92.717l7.052.02a.644.644,0,0,1,.63.766,36.923,36.923,0,0,1-2.591,8.375,35.9,35.9,0,0,1-5.047,8.042c-.015-5.643-.03-11.56-.045-17.2",
    transform: "translate(-1213.125 -73.553)",
    fill: "#444245"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10958",
    "data-name": "Group 10958",
    transform: "translate(244.996 11.77)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10957",
    "data-name": "Group 10957"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10956",
    "data-name": "Group 10956",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29588",
    "data-name": "Path 29588",
    d: "M1223.7,56.941l-38.422,32.364,23.251-1.864,33.562-28.27c-4.583-.631-11.249-1.493-18.391-2.23",
    transform: "translate(-1185.278 -56.941)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10961",
    "data-name": "Group 10961",
    transform: "translate(275.777 15.104)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10960",
    "data-name": "Group 10960"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10959",
    "data-name": "Group 10959",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29589",
    "data-name": "Path 29589",
    d: "M1366.392,74.554a1.938,1.938,0,0,0-.657-1.48L1334.2,99.636l13.685-1.1,18.392-15.492Z",
    transform: "translate(-1334.201 -73.074)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10964",
    "data-name": "Group 10964",
    transform: "translate(223.929 10.435)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10963",
    "data-name": "Group 10963"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10962",
    "data-name": "Group 10962",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29590",
    "data-name": "Path 29590",
    d: "M1126.94,50.482l-43.585,36.713,7.986-1.353,41.468-34.929q-2.955-.232-5.868-.43",
    transform: "translate(-1083.356 -50.482)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10967",
    "data-name": "Group 10967",
    transform: "translate(159.043 9.251)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10966",
    "data-name": "Group 10966"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10965",
    "data-name": "Group 10965",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29591",
    "data-name": "Path 29591",
    d: "M820.294,45.951,769.443,88.784l9.281,1.061a55.752,55.752,0,0,0,10.235.222l53.8-45.313c-6.765.045-14.407.353-22.46,1.2",
    transform: "translate(-769.443 -44.754)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10970",
    "data-name": "Group 10970",
    transform: "translate(186.684 9.289)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10969",
    "data-name": "Group 10969"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10968",
    "data-name": "Group 10968",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29592",
    "data-name": "Path 29592",
    d: "M959.253,45.025q-1.75-.051-3.645-.085L903.17,89.11l15.5-2.627,48.95-41.232q-4.242-.149-8.369-.226",
    transform: "translate(-903.17 -44.94)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_29593",
    "data-name": "Path 29593",
    d: "M1510.049,293.176a9.75,9.75,0,1,1,9.75-9.75,9.761,9.761,0,0,1-9.75,9.75m0-17.953a8.2,8.2,0,1,0,8.2,8.2,8.213,8.213,0,0,0-8.2-8.2",
    transform: "translate(-1190.189 -217.108)",
    fill: "#b82e37"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10973",
    "data-name": "Group 10973",
    transform: "translate(133 17.557)",
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10972",
    "data-name": "Group 10972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10971",
    "data-name": "Group 10971",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29594",
    "data-name": "Path 29594",
    d: "M679.427,87.549q-2.558,1.053-5.143,2.232l-30.838,25.975a2.207,2.207,0,0,0,1.961,2.153l1.639.187,39.366-33.159q-3.526,1.194-6.986,2.611",
    transform: "translate(-643.447 -84.938)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_29595",
    "data-name": "Path 29595",
    d: "M1727.946,203.462l18.289,19.484a111.28,111.28,0,0,0-7.828-23.014q-1.092-2.337-2.279-4.508a24.484,24.484,0,0,0-3.138-1.994,25.42,25.42,0,0,0-7.555-2.695c-.108-.018-.157-.022-.412-.056v5.7a10.426,10.426,0,0,0,2.923,7.087",
    transform: "translate(-1368.463 -151.267)",
    fill: "#931b26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29596",
    "data-name": "Path 29596",
    d: "M1729.2,140.829a24.82,24.82,0,0,0-7.563-2.574,2.073,2.073,0,0,1-1.755-1.969V127.4c0-.094-.111-.19-.184-.283a9.047,9.047,0,0,1-.835-1.368v11.629a2.039,2.039,0,0,0,1.719,1.969,25.084,25.084,0,0,1,10.66,4.568q-.8-1.464-1.628-2.851c-.14-.078-.27-.158-.413-.234",
    transform: "translate(-1363.578 -99.756)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10976",
    "data-name": "Group 10976",
    transform: "translate(134.856 9.245)",
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10975",
    "data-name": "Group 10975"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10974",
    "data-name": "Group 10974",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29597",
    "data-name": "Path 29597",
    d: "M823.883,50.119c-4.553-.668-17.651-2.511-30.472-3.579-7.884-.657-15.524-1.106-22.911-1.39v0l-.666-.021q-4.819-.179-9.5-.269c-18.047-.525-47.764.084-73.787,10.793-3.3,1.358-6.621,2.87-10.02,4.543h0l-.025.013q-1.924.948-3.887,1.967l-.13.066v0c-3.175,1.649-6.432,3.433-9.817,5.365-2.805,1.6-4.925,2.868-6.474,3.823a9.594,9.594,0,0,0-3.77,4.361c.223-.166.453-.326.691-.474,1.6-.993,3.8-2.311,6.7-3.976,4.2-2.41,8.213-4.6,12.115-6.59l-5.088,22.9,4.989.57,4.282-25.541c2.838-1.364,5.631-2.621,8.407-3.77,26.923-11.138,57.667-11.771,76.339-11.225q3.67.069,7.434.195l-.249,31.294,2.323-.179.119-31.037c7.916.293,16.116.771,24.588,1.48,12.37,1.036,24.984,2.772,30.451,3.565l.012-.931a1.939,1.939,0,0,0-1.657-1.946",
    transform: "translate(-652.428 -44.725)",
    fill: "#438689"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_29598",
    "data-name": "Path 29598",
    d: "M1122.2,39.932l-7.469,38.406,20.2-2.018.14-36.378Z",
    transform: "translate(-884.314 -31.678)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29599",
    "data-name": "Path 29599",
    d: "M711.6,121.365l-6.638,29.879,5.547-1.143,5.274-31.464Z",
    transform: "translate(-559.247 -94.115)",
    fill: "#535054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29600",
    "data-name": "Path 29600",
    d: "M1181.59,42.7c-14.454-2.539-30.112-4.673-46.863-6.1-12.2-1.039-23.865-1.607-34.92-1.819a261.321,261.321,0,0,0-31.24.816c8.755-.48,16.718-.43,23.237-.236,11.054.212,22.717.78,34.92,1.819,16.751,1.426,32.409,3.561,46.862,6.1a3.494,3.494,0,0,1,2.781,4.284,43,43,0,0,1-6.417,14.226,15.3,15.3,0,0,1-11.342,6.486l7.843-.564a15.3,15.3,0,0,0,11.5-6.5,43,43,0,0,0,6.417-14.226,3.494,3.494,0,0,0-2.781-4.284",
    transform: "translate(-847.696 -27.484)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29601",
    "data-name": "Path 29601",
    d: "M1212.215,201.708l60.192-4.33c.053,0,.106-.012.159-.016l-60,4.316c-.115.008-.231.02-.346.029",
    transform: "translate(-961.652 -156.568)",
    fill: "#535054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29602",
    "data-name": "Path 29602",
    d: "M1815.461,641.865c-.01-.263-.023-.547-.04-.851.015.283.031.566.04.851",
    transform: "translate(-1440.176 -508.517)",
    fill: "#579988"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29603",
    "data-name": "Path 29603",
    d: "M1803.158,586.676a42.692,42.692,0,0,0-3.2-14.158,44.219,44.219,0,0,1,3.2,14.158",
    transform: "translate(-1427.913 -454.179)",
    fill: "#569687"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29604",
    "data-name": "Path 29604",
    d: "M1536.264,92.738l-7.052-.021c0,.488,0,.981,0,1.473l4.8.014a.645.645,0,0,1,.631.766,36.92,36.92,0,0,1-2.591,8.375,35.87,35.87,0,0,1-2.8,5.028c0,.517,0,1.035,0,1.548a35.9,35.9,0,0,0,5.047-8.042,36.934,36.934,0,0,0,2.59-8.375.644.644,0,0,0-.63-.766",
    transform: "translate(-1213.125 -73.553)",
    fill: "#413f42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29605",
    "data-name": "Path 29605",
    d: "M1517.717,110.048h-2.482a.827.827,0,0,1-.827-.827V93.629a.9.9,0,0,1,.893-.893h2.417Z",
    transform: "translate(-1201.381 -73.568)",
    fill: "#5b575c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29606",
    "data-name": "Path 29606",
    d: "M527.35,69.53,483.533,95.09a12.935,12.935,0,0,1-7.057,1.765l-1.917,1.057c-.163.088-.328.17-.492.254a12.922,12.922,0,0,0,9.466-1.439l49.655-28.966a5.857,5.857,0,0,0,1.862-1.709c-.175.078-.35.151-.526.23-2.55,1.139-4.931,2.217-7.174,3.248",
    transform: "translate(-376.078 -52.399)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10980",
    "data-name": "Group 10980",
    transform: "translate(100.398 17.13)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10979",
    "data-name": "Group 10979"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10978",
    "data-name": "Group 10978",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29607",
    "data-name": "Path 29607",
    d: "M492.778,108.436,536.6,82.875a346.382,346.382,0,0,0-40.184,21.432l-10.69,5.894a12.936,12.936,0,0,0,7.057-1.765",
    transform: "translate(-485.721 -82.875)",
    fill: "#63aab6"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_29608",
    "data-name": "Path 29608",
    d: "M485.5,354.952h-9.8a.83.83,0,0,1-.83-.83v-1.9a.83.83,0,0,1,.83-.83h9.8a.83.83,0,0,1,.83.83v1.9a.83.83,0,0,1-.83.83",
    transform: "translate(-376.719 -278.757)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29609",
    "data-name": "Path 29609",
    d: "M651.8,254.317l-7.807,4.794a.772.772,0,0,0-.379.668v-.021a.863.863,0,0,0,.8.876h11.724Z",
    transform: "translate(-510.581 -201.75)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29610",
    "data-name": "Path 29610",
    d: "M683.07,224.336c-.566-1.2-1.344-2.832-1.947-4.056a3.065,3.065,0,0,1,.628-3.55,19.607,19.607,0,0,1,19.708-4.623,7.976,7.976,0,0,1,3.809,2.547,10.237,10.237,0,0,1,1.157,1.769,10.794,10.794,0,0,1,1.04,6.4,2.448,2.448,0,0,1-.248.774l-.269.6a3.53,3.53,0,0,1-3.083,1.957H685.819a3.1,3.1,0,0,1-2.748-1.813",
    transform: "translate(-540.09 -167.52)",
    fill: "#cc333d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29611",
    "data-name": "Path 29611",
    d: "M725.426,231.878a10.179,10.179,0,0,0-.746-1.226,10.926,10.926,0,0,1,.653,5.548,2.456,2.456,0,0,1-.248.775l-.269.616a3.606,3.606,0,0,1-3.083,2.033s-18.089,1.983-16.913,1.983h18.046a3.531,3.531,0,0,0,3.083-1.957l.269-.561a2.55,2.55,0,0,0,.248-.792,10.851,10.851,0,0,0-1.04-6.417",
    transform: "translate(-559.091 -182.977)",
    fill: "#b82e37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29612",
    "data-name": "Path 29612",
    d: "M685.105,224.609c-.566-1.2-1.345-2.8-1.947-4.028a3.045,3.045,0,0,1,.628-3.536,19.76,19.76,0,0,1,8.871-4.962,19.541,19.541,0,0,1,7.167-.445,19.572,19.572,0,0,0-18.072,5.05,3.039,3.039,0,0,0-.628,3.532c.6,1.224,1.381,2.833,1.947,4.036a3.049,3.049,0,0,0,2.748,1.757h.628a3.157,3.157,0,0,1-1.342-1.405",
    transform: "translate(-540.09 -167.496)",
    fill: "#e03843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29613",
    "data-name": "Path 29613",
    d: "M1729.983,202.7a10.427,10.427,0,0,1-2.923-7.087v-4.527a15.909,15.909,0,0,0-1.627-.349c-.107-.018-.155-.022-.41-.056v5.7a10.425,10.425,0,0,0,2.924,7.087l18.289,19.484q-.422-1.906-.952-3.948Z",
    transform: "translate(-1368.463 -151.267)",
    fill: "#801721"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29614",
    "data-name": "Path 29614",
    d: "M1737.8,204.25l15.3,16.3a111.459,111.459,0,0,0-6.876-19.066q-1.092-2.337-2.279-4.508a24.562,24.562,0,0,0-3.14-1.994,27.2,27.2,0,0,0-5.929-2.346v4.527a10.426,10.426,0,0,0,2.924,7.087",
    transform: "translate(-1376.28 -152.818)",
    fill: "#931b26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29615",
    "data-name": "Path 29615",
    d: "M1772.539,237.944a27.983,27.983,0,0,0-4.358-1.828.986.986,0,0,0-1.28.943v3.216a9.714,9.714,0,0,0,.428,2.825l11.177,11.906a111.47,111.47,0,0,0-5.966-17.063",
    transform: "translate(-1401.684 -187.274)",
    fill: "#ab1f2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29616",
    "data-name": "Path 29616",
    d: "M1828.173,471.9a51.814,51.814,0,0,1-6.538,16.858,51.235,51.235,0,0,1-10.05,11.933,44.283,44.283,0,0,1,.82,6.982l2.872-.3a11.927,11.927,0,0,0,9.668-6.969,47.246,47.246,0,0,0,3.228-28.5",
    transform: "translate(-1437.133 -374.356)",
    fill: "#b82e37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29617",
    "data-name": "Path 29617",
    d: "M38.624,534.24a21.915,21.915,0,0,1-19.25,11.038l-10.18-.1.006.012c-1.413.2-2.775.339-4.093.46a1.921,1.921,0,0,0-1.262,3.188,14.14,14.14,0,0,0,9.572,4.663l29.654,2h.242l.031,0v0h2.765a36.807,36.807,0,0,1,7.6-34.74H46.333Z",
    transform: "translate(-2.661 -413.114)",
    fill: "#b82e37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29618",
    "data-name": "Path 29618",
    d: "M1741.361,216.067l-18.3-19.484a10.426,10.426,0,0,1-2.923-7.087v-5.776a2.116,2.116,0,0,1-1.273-1.711v8.306a10.382,10.382,0,0,0,2.878,7.087l20.2,21.59c-.011-.057-.009-.114-.02-.171-.174-.891-.354-1.809-.562-2.753",
    transform: "translate(-1363.578 -144.387)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29619",
    "data-name": "Path 29619",
    d: "M1136.561,222.972a127.112,127.112,0,0,0-5.273,32.479c-.405,17.429,1.618,48.32,1.638,48.629l1.543-.1c-.02-.309-2.039-31.132-1.635-48.492a125.148,125.148,0,0,1,5.222-32.111l.025-.077.141-1.3q-.79.087-1.577.2Z",
    transform: "translate(-897.41 -176.111)",
    fill: "#b82e37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29620",
    "data-name": "Path 29620",
    d: "M1178.252,39.582l.165-1.518-.83-.018-.721-.02-.165,1.523q.775.015,1.552.032",
    transform: "translate(-933.478 -30.166)",
    fill: "#535054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29621",
    "data-name": "Path 29621",
    d: "M1157.573,215.24l-.16,1.472q.787-.11,1.577-.2l.155-1.428q-.787.065-1.572.153",
    transform: "translate(-918.177 -170.629)",
    fill: "#535054"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29622",
    "data-name": "Path 29622",
    d: "M1158.993,73.366l4.205-38.714-1.555-.007-4.228,38.919c.265-.036,1.35-.168,1.577-.2",
    transform: "translate(-918.18 -27.484)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29623",
    "data-name": "Path 29623",
    d: "M581.264,302.807l-.017.058-.018.064-.006.066a236.378,236.378,0,0,0,3.473,65.983l1.376-.268a234.947,234.947,0,0,1-3.467-65.414c-.228-.078-.457-.155-.683-.239s-.438-.164-.658-.249",
    transform: "translate(-460.367 -240.217)",
    fill: "#b82e37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29624",
    "data-name": "Path 29624",
    d: "M592.768,192.976q-.878.555-1.776,1.129l-6.1,21.574c.22.085.44.168.658.249s.455.161.683.239c0-.037.006-.074.009-.112Z",
    transform: "translate(-463.998 -153.088)",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29625",
    "data-name": "Path 29625",
    d: "M1648.7,49.708l-5.411,62.382,1.4.121,5.411-62.383a36.9,36.9,0,0,0-2.315-16.338,36.469,36.469,0,0,0-3.507-6.841l-1.834-.206a35.1,35.1,0,0,1,4.032,7.552,35.488,35.488,0,0,1,2.227,15.713",
    transform: "translate(-1302.947 -20.977)",
    fill: "#b82e37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29626",
    "data-name": "Path 29626",
    d: "M1755.612,421.236l-9.239,9.544,1.007.975,8.826-9.117a13.377,13.377,0,0,1,9.611-4.073h5.8l-.85-1.4h-5.539a13.377,13.377,0,0,0-9.612,4.073",
    transform: "translate(-1385.4 -330.936)",
    fill: "#b82e37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29627",
    "data-name": "Path 29627",
    d: "M218.054,423.915a42.584,42.584,0,0,1,42.568,41.4h.006c.006-.3.012-.608.012-.913a42.585,42.585,0,0,0-85.17,0c0,.325.008.648.015.971a42.585,42.585,0,0,1,42.569-41.452",
    transform: "translate(-139.201 -334.624)",
    fill: "#e03843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29628",
    "data-name": "Path 29628",
    d: "M1809.091,633.667l.042-.006q0-.392-.013-.783c-.008.263-.017.527-.029.789",
    transform: "translate(-1435.154 -502.063)",
    fill: "#068b9e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3256",
    "data-name": "Rectangle 3256",
    width: 178.685,
    height: 4.22,
    transform: "translate(118.048 124.54)",
    fill: "#e03843"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29629",
    "data-name": "Path 29629",
    d: "M1467.993,431.985a42.615,42.615,0,0,0-41.284,53.06h6.034a36.77,36.77,0,1,1,72.018-10.476q0,.922-.045,1.832l4.219-.632h0a12.049,12.049,0,0,0,1.63-.286c.006-.3.011-.608.011-.913a42.585,42.585,0,0,0-42.585-42.584",
    transform: "translate(-1130.779 -342.694)",
    fill: "#bf3039"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29630",
    "data-name": "Path 29630",
    d: "M240.717,243.181l-43.692,27.428.822,1.31,43.692-27.428a4.33,4.33,0,0,0,2.006-3.308l.3-3.745-1.58.353L242,241.059a2.777,2.777,0,0,1-1.286,2.122",
    transform: "translate(-156.3 -188.36)",
    fill: "#b82e37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29631",
    "data-name": "Path 29631",
    d: "M112.639,407.163,97.216,393.33a10.125,10.125,0,0,0-6.77-2.591H67.4l1.107-1.4H90.446a11.526,11.526,0,0,1,7.706,2.949l15.423,13.833Z",
    transform: "translate(-53.466 -308.862)",
    fill: "#b82e37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29632",
    "data-name": "Path 29632",
    d: "M103.76,299.408c-10.714,4.706-16.8,9.8-20.355,16.489a72.084,72.084,0,0,0-4.107,9.045.951.951,0,0,0,1.254,1.193c3.274-1.265,7.428-3.441,10.948-5.067.755-.349,1.5-.715,2.234-1.108,3.961-2.124,8.4-4.659,12.616-7.123.063-.926.13-1.831.186-2.578a3.515,3.515,0,0,1,1.779-2.8c3.137-1.772,10.116-5.359,14.96-5.213l1.816-8.4s-11.548,1.26-21.332,5.558",
    transform: "translate(-62.861 -233.112)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29633",
    "data-name": "Path 29633",
    d: "M80.662,325.488a72.042,72.042,0,0,1,4.107-9.045c3.559-6.685,9.641-11.782,20.355-16.489a82,82,0,0,1,19.806-5.357l.161-.746s-11.548,1.26-21.332,5.558c-10.714,4.706-16.8,9.8-20.355,16.489a72.043,72.043,0,0,0-4.107,9.045.951.951,0,0,0,1.254,1.193l.1-.04a.9.9,0,0,1,.009-.607",
    transform: "translate(-62.861 -233.112)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29634",
    "data-name": "Path 29634",
    d: "M158.1,313.477c-7.474,3.283-11.716,6.839-14.2,11.5-1.494,2.807-4.151,8.7-4.151,8.7s7.343-3.957,9.8-5.092c.527-.243,1.048-.5,1.559-.773,2.763-1.482,5.863-3.25,8.8-4.969.044-.646.09-1.278.13-1.8a2.452,2.452,0,0,1,1.241-1.951c2.188-1.236,7.057-3.738,10.436-3.636l1.267-5.858a58.45,58.45,0,0,0-14.88,3.877",
    transform: "translate(-110.868 -245.606)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29635",
    "data-name": "Path 29635",
    d: "M212.91,339.95c3.009-1.7,9.551-5.067,14.355-5.21l.06-.275c-4.844-.147-11.823,3.44-14.96,5.212a3.516,3.516,0,0,0-1.779,2.8c-.056.747-.123,1.652-.186,2.579l.589-.345c.049-.706.1-1.381.143-1.961a3.515,3.515,0,0,1,1.779-2.8",
    transform: "translate(-166.91 -265.328)",
    fill: "#e8b162"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29636",
    "data-name": "Path 29636",
    d: "M229.359,335.791l-.037.169s-7.548,4.7-16.241,9.8q-.022.306-.043.618c8.938-5.23,16.829-10.143,16.829-10.143l.1-.445c-.2-.006-.4,0-.605,0",
    transform: "translate(-169.004 -266.379)",
    fill: "#ffc36c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29637",
    "data-name": "Path 29637",
    d: "M229.524,335.814c-4.8.143-11.346,3.51-14.355,5.21a3.515,3.515,0,0,0-1.779,2.8c-.044.579-.094,1.255-.143,1.961,8.693-5.1,16.241-9.8,16.241-9.8Z",
    transform: "translate(-169.169 -266.402)",
    fill: "#ffc36c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29638",
    "data-name": "Path 29638",
    d: "M134.1,273.769c-7.4.716-29.237,3-40.485,8.024-12.317,5.506-19.31,11.47-23.4,19.29a85.06,85.06,0,0,0-4.721,10.582,1.1,1.1,0,0,0,1.442,1.4q6.225-2.447,12.646-5.339c21.1-11.42,38.2-21.851,54.934-32.768a.646.646,0,0,0-.414-1.184m-21.88,12.991c-3.427,1.955-13.875,8.483-16.829,10.143-4.212,2.464-8.655,5-12.616,7.123-.733.393-1.48.759-2.234,1.108-3.52,1.626-7.674,3.8-10.948,5.067a.951.951,0,0,1-1.254-1.193,72.052,72.052,0,0,1,4.107-9.045c3.56-6.685,9.642-11.782,20.355-16.489,9.784-4.3,21.332-5.558,21.332-5.558Z",
    transform: "translate(-51.899 -217.179)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29639",
    "data-name": "Path 29639",
    d: "M1011.586,308.24a74.1,74.1,0,0,1,10.081,2.6q1.862.623,3.577,1.3l1.3-4.878-14.959.976",
    transform: "translate(-802.493 -243.753)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29640",
    "data-name": "Path 29640",
    d: "M1047.448,299.036l-.03.052a12.035,12.035,0,0,1-4.949,4.677,3.873,3.873,0,0,0-.759.451.384.384,0,0,0,.265.654h6.491a4.432,4.432,0,0,0,4.34-3.373l.013-.058c.463-2.094-.29-4.8-1.679-5.147-1.3-.329-2.948,1.475-3.693,2.745",
    transform: "translate(-826.302 -235.017)",
    fill: "#b82e37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29641",
    "data-name": "Path 29641",
    d: "M1020.371,298.249H1004.2a.836.836,0,0,1-.851-.9v-.011c.041-.333.331-1.243,4.623-2.345a37.68,37.68,0,0,1,5.528-.976s6.287-.673,7.8.651a2.966,2.966,0,0,1,.938,1.463l.007.034a1.824,1.824,0,0,1-1.885,2.08",
    transform: "translate(-795.957 -233.112)",
    fill: "#e03843"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3257",
    "data-name": "Rectangle 3257",
    width: 179.843,
    height: 12.655,
    transform: "translate(117.563 127.969)",
    fill: "#bf3039"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29642",
    "data-name": "Path 29642",
    d: "M217.254,431.985a42.61,42.61,0,0,0-41.328,52.883l3.048.205h.242l.031,0v0h2.765a36.768,36.768,0,1,1,70.484,0h6.036a42.615,42.615,0,0,0-41.278-53.088",
    transform: "translate(-138.566 -342.694)",
    fill: "#bf3039"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29643",
    "data-name": "Path 29643",
    d: "M551.194,673.436h11.5l-.01-.028H739.227a36.691,36.691,0,0,1-.941-3.981H552.143a36.647,36.647,0,0,1-.949,4.01",
    transform: "translate(-437.263 -531.057)",
    fill: "#b82e37"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellYourCar);
export default __webpack_public_path__ + "static/media/sell_your_car.6c140891207d4e68a40b8f5733bfff5e.svg";
export { ForwardRef as ReactComponent };